import Vue from 'vue'
import App from './App.vue'
import 'sanitize.css'
import { Button, Input, Dialog, Message, Option, Select } from 'element-ui';
import './styles/element-variables.sass'
import './styles/common.scss'
import './config/axios.config'

Vue.use(Button)
Vue.use(Input)
Vue.use(Dialog)
Vue.use(Option)
Vue.use(Select)

// if(window.innerWidth <= 1023) {
//   console.log(Vue.prototype)
//   Vue.prototype.$message = ({message}) => {
//     Toast(message)
//   }
// } else {
  Vue.prototype.$message = Message
// }

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
